// Shared pdf.js loader (self-hosted under /pdfjs with CDN fallback)
const PDFJS_BASE = '/pdfjs';
const PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174';

let pdfJsLoadPromise = null;

export const loadPdfJs = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('No window'));
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if (pdfJsLoadPromise) return pdfJsLoadPromise;
  pdfJsLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${PDFJS_BASE}/pdf.min.js`;
    script.async = true;
    script.onload = () => {
      try {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS_BASE}/pdf.worker.min.js`;
        resolve(window.pdfjsLib);
      } catch (e) { reject(e); }
    };
    script.onerror = () => {
      const s2 = document.createElement('script');
      s2.src = `${PDFJS_CDN}/pdf.min.js`;
      s2.onload = () => {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS_CDN}/pdf.worker.min.js`;
        resolve(window.pdfjsLib);
      };
      s2.onerror = reject;
      document.head.appendChild(s2);
    };
    document.head.appendChild(script);
  });
  return pdfJsLoadPromise;
};

// Render a PDF into an array of {src, width, height} entries
export const renderPdfToPages = async (pdfUrl, { renderScale = 2.0 } = {}) => {
  const pdfjsLib = await loadPdfJs();
  let source;
  if (pdfUrl.startsWith('data:')) {
    const base64 = pdfUrl.split(',')[1];
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    source = { data: bytes };
  } else {
    source = { url: pdfUrl, withCredentials: false };
  }
  const pdf = await pdfjsLib.getDocument(source).promise;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const out = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale: renderScale });
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = Math.floor(viewport.width * dpr);
    canvas.height = Math.floor(viewport.height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    await page.render({ canvasContext: ctx, viewport }).promise;
    out.push({
      src: canvas.toDataURL('image/jpeg', 0.85),
      width: viewport.width / renderScale,
      height: viewport.height / renderScale,
    });
  }
  return out;
};
